import {
  AvailablePaidMembershipPlanGroup,
  AvailablePaidMembershipPlanInGroup,
} from '@/models/api/paid-member-price/member-plan/group/available-paid-membership-plan-group'
import { NextPayment } from '@/services/api/paid-member-subscription'

/**
 * viewから{@link AvailablePaidMembershipPlanGroup}と、そのグループの{@link NextPayment}をセットで扱うためのデータ構造
 */
export class PlanGroupViewModel {
  static createWithNextPayment(group: AvailablePaidMembershipPlanGroup, nextPayment: NextPayment): PlanGroupViewModel {
    return new PlanGroupViewModel(group, nextPayment)
  }

  static createWithoutNextPayment(group: AvailablePaidMembershipPlanGroup): PlanGroupViewModel {
    return new PlanGroupViewModel(group)
  }

  private constructor(
    private readonly group: AvailablePaidMembershipPlanGroup,
    public readonly nextPayment?: NextPayment
  ) {}

  get id(): string {
    return this.group.id
  }

  get currentPlan(): AvailablePaidMembershipPlanInGroup | undefined {
    return this.group.currentPlan
  }

  get plansExcludeCurrentPlan(): AvailablePaidMembershipPlanInGroup[] {
    return this.group.plansExcludeCurrentPlan
  }

  get nextPaymentPlan(): AvailablePaidMembershipPlanInGroup | undefined {
    const nextPayment = this.nextPayment
    if (!nextPayment) {
      return undefined
    }

    return this.group.plans.find(p => p.externalId === nextPayment.plan_id)
  }
}
